import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { colors } from '../../../styles/theme'

const S = {}

const scaleRatio = 0.66

S.Label = styled.div`
  position: relative;
  max-width: 100%;
  color: ${colors.white};
  text-align: start;
  height: 3.75rem;
  padding-block-start: 1.5rem;
  box-sizing: border-box;
  border-block-end: 0.125rem solid ${colors.scarpaFlow};

  ${({ isFocus, isFilled }) =>
    (isFocus || isFilled) &&
    css`
      .label-text-wrapper {
        transform: translateY(-1.875rem);
      }

      .label-text {
        color: ${colors.silverChalice};
        transform: scale3d(${scaleRatio}, ${scaleRatio}, 1);
        width: calc(100% / ${scaleRatio});
      }
    `};

  ${({ isFocus, isResetFocused, accentColor }) =>
    (isFocus || isResetFocused) &&
    css`
      border-block-end-color: ${accentColor ? accentColor : colors.orange};
    `};

  ${({ isError }) =>
    isError &&
    css`
      border-block-end-color: ${colors.pomegranate};

      .label-text {
        color: ${colors.pomegranate};
      }
    `};

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      .label-text {
        color: ${colors.scarpaFlow};
      }
    `};

  ${({ isReadOnly }) =>
    isReadOnly &&
    css`
      border-block-end-color: ${colors.scarpaFlow};

      input {
        color: ${colors.silverChalice};
      }
    `};

  .label-text-wrapper {
    position: absolute;
    overflow: hidden;
    inset-inline: 0;
    transition: transform 0.2s cubic-bezier(0.5, 0, 0.25, 1);
    inset-block-end: 0.375rem;
  }

  .label-text {
    display: block;
    transition: transform 0.2s cubic-bezier(0.5, 0, 0.25, 1);

    html:not([dir]) &,
    [dir='ltr'] & {
      transform-origin: bottom left;
    }

    [dir='rtl'] & {
      transform-origin: bottom right;
    }
  }

  &.base-input {
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 1.625rem;
  }
`

export default S
